import template from './index.html'
import controller from './controller'

partPartGroup.vsName = 'partPartGroup'
partPartGroup.vsNgType = 'directive'

partPartGroup.$inject = []
function partPartGroup() {
  return {
    restrict: 'E',
    controller: controller,
    controllerAs: 'ctrl',
    bindToController: true,
    templateUrl: template,
    scope: {
      partGroup: '=',
      part: '='
    }
  }
}

export default partPartGroup